import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { from, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../auth/core/auth.service';
import { AbstractApiDataService } from './abstract-api-data.service';
import { ProjectionAuthService } from './auth.service';
import { ODataConfig } from './odata-config.model';

@Injectable({
  providedIn: 'root',
})
export abstract class ODataApiDataService<TData> extends AbstractApiDataService {
  constructor(protected http: HttpClient, private authService: ProjectionAuthService) {
    super();
  }

  // GET : odata format
  odataList(requestUrl: string, params?: HttpParams): Observable<TData[]> {
    return this.http.get(requestUrl, { params }).pipe(
      // tslint:disable-next-line: no-string-literal
      map(res => res['value'] as TData[]),
      catchError(this.handleError('odataList', [])),
    );
  }

  odataGetById(requestUrl: string, params?: HttpParams): Observable<TData> {
    return this.http.get(requestUrl, { params }).pipe(
      // tslint:disable-next-line: no-string-literal
      map(res => res['value'] as TData),
      catchError(this.handleError<TData>(`odataGetById request=${requestUrl}`)),
    );
  }

  odataGetDxDataSource(config: ODataConfig): Observable<DataSource> {
    // `AuthService` doesn't return an access token. Instead it receives an HTTP request and returns a cloned request
    // with the necessary authentication header(s). To obtain the access token, we have to (1) create an HTTP request,
    // (2) pass it to `AuthService.authenticateReq` and (3) get the `Authorization` header from the returned request.
    return from(this.authService.authenticateReq(new HttpRequest<any>('GET', config.endpoint))).pipe(
      map(req => {
        return new DataSource({
          store: new ODataStore({
            version: 4,
            url: config.endpoint,
            beforeSend(request) {
              request.headers.Authorization = req.headers.get('Authorization');
            },
            key: config.key,
            keyType: config.keyType,
          }),
          filter: config.filter,
          sort: config.sort,
          expand: config.expand,
          map: config.parser,
        });
      }),
    );
  }
}
